export default "__VITE_PUBLIC_ASSET__10e135c3__"